<template>
    <div class="carType">
      <div class="hotCarsTitle">
        <div class="hctMain clearfix">
          <div class="hctMainImg"><img :src="hctIcon" alt=""></div>
          <div class="hctMainTitle">车型系列介绍</div>
        </div>
      </div>
      <!--按钮-->
      <ul class="carTypeButton">
        <li v-for="(item,index) in ctbMains" @click="bgColor(index)" :class="{'bgColor':index==color}">{{item.name}}</li>
      </ul>
      <div class="ctbImg"><img :src="ctbImg" alt=""></div>
      <h5>{{ctbTitle}}</h5>
      <!--车型介绍-->
      <ul  class="carTypeUse">
        <li>
          <h3>{{top}}</h3>
          <p>{{topMain}}</p>
        </li>
        <li>
          <h3>{{center}}</h3>
          <p>{{centerMain}}</p>
        </li>
        <li>
          <h3>{{bottom}}</h3>
          <p>{{bottomMain}}</p>
        </li>
      </ul>

    </div>
</template>

<script>
    export default {
        name: 'CarType',
        data () {
            return {
              hctIcon:require("../../assets/icon_hotCar.png"),
//              ctbMains:['大中巴车系列','豪华车系列','婚庆车系列','通勤班车系列','商务车系列','小轿车系列'],
              ctbMains: [
                {
                  "name": '大中巴系列',
                  "img": require("../../assets/icon_carType02.jpg"),
                  "top": '提供车型品牌：',
                  "topMain": '金龙、宇通、金旅、青年、海格、申龙、安凯',
                  "center": '车型及座位数：',
                  "centerMain": '19座、22座、33座、37座、45座、51座、55座、57座',
                  "bottom": '适合使用场景：',
                  "bottomMain": '班车接送、旅游包车、婚宴包车、会议接送、商务接待考察'
                },
                {
                  "name": "豪华车系列",
                  "img": require("../../assets/icon_carType07.jpg"),
                  "top": '提供车型品牌：',
                  "topMain": '奔驰、宝马、奥迪、加长林肯、加长凯迪拉克、加长悍马、劳斯莱斯幻影',
                  "center": '满足用车需求：',
                  "centerMain": '可根据客户需求提供自驾服务（部份加长车型需由我司配备专业驾驶员）',
                  "bottom": '适合使用场景：',
                  "bottomMain": '婚庆花车、会议接送、商务考察、商旅接待'
                },
                {
                  "name": '婚庆车系列',
                  "img": require("../../assets/icon_carType06.jpg"),
                  "top": '多元化的服务：',
                  "topMain": '可提供陪驾服务、可布置花车、可派现场调度员、可派司仪服务',
                  "center": '提供车型品牌：',
                  "centerMain": '奔驰S级、宝马七系、奥迪A8、加长林肯、加长悍马、劳斯莱斯幻影',
                  "bottom": '行业经验：',
                  "bottomMain": '公司年累计接待婚庆用车客户125场，拥有行业12年经验，您值得托付'
                },
                {
                  "name": '通勤班车系列',
                  "img": require("../../assets/icon_carType04.jpg"),
                  "top": '提供车型品牌：',
                  "topMain": '金龙、宇通、金旅、青年、海格、申龙、安凯',
                  "center": '车型及座位数：',
                  "centerMain": '19座、22座、33座、37座、45座、51座、55座、57座',
                  "bottom": '我们的优势：',
                  "bottomMain": '十二年承接通勤班车，价格低廉车况超新可选择车型多，我们已在运营班车有24台'
                },
                {
                  "name": "商务车系列",
                  "img": require("../../assets/icon_carType01.jpg"),
                  "top": '提供车型品牌：',
                  "topMain": '奔驰威霆、新款别克GL8、丰田海狮12座、埃尔法、奥德赛',
                  "center": '行业经验及优势：',
                  "centerMain": '十二年会议承接经验，年均接待110场服务商务人士40000+',
                  "bottom": '满足用车需求：',
                  "bottomMain": '可根据客户需求提供自驾服务及陪驾包车服务'
                },
                {
                  "name": '小轿车系列',
                  "img": require("../../assets/icon_carType03.jpg"),
                  "top": '提供车型品牌：',
                  "topMain": '丰田卡罗拉、凯美瑞、汉兰达、日产天籁、轩逸、现代索纳塔、大众迈腾、帕萨特、途观、朗逸、本田CRV、飞度、思域、雅阁、宝马三系、五系奔C级、E级',
                  "center": '',
                  "centerMain": '',
                  "bottom": '满足用车需求：',
                  "bottomMain": '可根据客户需求提供自驾服务及陪驾包车服务'
                }
              ],
              color:0,
              //初始默认信息
              ctbImg:require("../../assets/icon_carType01.jpg"),
              ctbTitle:'大中巴系列',
              top: '提供车型品牌：',
              topMain: '金龙、宇通、金旅、青年、海格、申龙、安凯',
              center: '车型及座位数：',
              centerMain: '19座、22座、33座、37座、45座、51座、55座、57座',
              bottom: '适合使用场景：',
              bottomMain: '班车接送、旅游包车、婚宴包车、会议接送、商务接待考察'
            }
        },
      methods:{
        bgColor:function(index){
          this.color= index;
          this.ctbImg = this.ctbMains[index].img;
          this.ctbTitle = this.ctbMains[index].name;

          this.top=this.ctbMains[index].top;
          this.topMain=this.ctbMains[index].topMain;
          this.center=this.ctbMains[index].center;
          this.centerMain=this.ctbMains[index].centerMain;
          this.bottom=this.ctbMains[index].bottom;
          this.bottomMain=this.ctbMains[index].bottomMain;
        }
      }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .clear {overflow: hidden;}
    .clearfix:before, .clearfix:after {clear: both;content: " ";display: table;}

    .hotCarsTitle{width: 100%;height: 60px;background: #f6f6f6}
    .hctMain{width: 340px;background: #2c3e50;background: linear-gradient(-45deg, transparent 45px, #2c3e50 0) bottom right;height: 60px; background-repeat: no-repeat;display: flex}
    .hctMainImg{display: flex;padding-left: 20px;box-sizing: border-box;align-items: center;height: 60px;}
    .hctMainImg img{width: 32px;height: 32px;vertical-align: middle}
    .hctMainTitle{display: flex;font-size:32px;font-family:PingFangSC-Semibold;font-weight:600;color:rgba(255,255,255,1);align-items: center;margin-left: 20px;}

    /*按钮*/
    .carTypeButton{padding: 0 24px;box-sizing: border-box;display: flex;justify-content: space-between;flex-wrap: wrap;margin-top: 24px}
    .carTypeButton li{width: 224px;height: 56px;line-height: 56px;background: #eee;font-size:24px;font-family:PingFangSC-Regular;font-weight:400;color: #2c3e50;margin-bottom: 16px;}
    .bgColor{background: #1dd2af!important;color: #ffffff!important;}

    .ctbImg{width: 700px;height: 400px;margin: 0 auto}
    .ctbImg img{width: 100%;height: 100%}
    .carType h5{width: 700px;height:60px;line-height: 60px;margin: 0 auto;background: #f6f6f6;font-size:28px;font-family:PingFangSC-Semibold;font-weight:600;color: #2c3e50}

    /*底下内容*/
    .carTypeUse{width: 700px;margin: 20px auto 0}
    .carTypeUse li{text-align: left}
    .carTypeUse li h3{font-size:24px;font-family:PingFangSC-Medium;font-weight:600;color: #2c3e50;margin: 10px 0}
    .carTypeUse li p{font-size:24px;font-family:PingFangSC-Medium;font-weight:400;color: #2c3e50;margin: 0}
</style>



// WEBPACK FOOTER //
// src/components/CarType/CarType.vue